import ComplementoINEResumen from './summary/ComplementoINEResumen';
import ComplementoDonatariasResumen from './summary/ComplementoDonatariasResumen';
import ComplementoCartaPorteResumen from './summary/ComplementoCartaPorteResumen';
import ComplementoAerolineasResumen from './summary/ComplementoAerolineasResumen';
import ComplementoVehiculosUsadosResumen from './summary/ComplementoVehiculosUsadosResumen';
import ComplementoComercioExteriorResumen from './summary/ComplementoComercioExteriorResumen';
import ComplementoImpuestosLocalesResumen from './summary/ComplementoImpuestosLocalesResumen';
import ComplementoParcialesConstruccionResumen from './summary/ComplementoParcialesConstruccionResumen';

const complementosResumenList = {
  Donatarias: ComplementoDonatariasResumen,
  INE: ComplementoINEResumen,
  parcialesconstruccion: ComplementoParcialesConstruccionResumen,
  VehiculoUsado: ComplementoVehiculosUsadosResumen,
  ComercioExterior: ComplementoComercioExteriorResumen,
  CartaPorte: ComplementoCartaPorteResumen,
  ImpuestosLocales: ComplementoImpuestosLocalesResumen,
  Aerolineas: ComplementoAerolineasResumen,
}

export default complementosResumenList;
